import React from 'react'
import { AccordionContainer } from '../../../../../../../../common/components/accordion/accordion.module'
import { InputLabelContainer } from '../../../../../../../../common/components/form/label/containers/input-label.container'

export const GatewayCockpitInsightBasicInfoComponent = ({ selectedInsightsEdges }: any) => {
  return (
    <>
      <AccordionContainer
        child={
          <div className='grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
            <div>
              <div className='font-semibold text-sm'>
                <InputLabelContainer
                  label="Edge Id"
                />
              </div>
              <div className='text-xs'>
                <InputLabelContainer
                  label={selectedInsightsEdges?.EdgeId || '-'}
                />
              </div>
            </div>
            <div>
              <div className='font-semibold text-sm'>
                <InputLabelContainer
                  label="Name"
                />
              </div>
              <div className='text-xs'>
                <InputLabelContainer
                  label={selectedInsightsEdges?.Name || '-'}
                />
              </div>
            </div>
            <div>
              <div className='font-semibold text-sm'>
                <InputLabelContainer
                  label="Total NPs"
                />
              </div>
              <div className='text-xs'>
                <InputLabelContainer
                  label={selectedInsightsEdges?.TotalNoOfNetworkParticipants || '0'}
                />
              </div>
            </div>
          </div>
        }
        expandedPanel="userInfo"
        headerTitle="Basic Details"
      />
    </>
  )
}
export default GatewayCockpitInsightBasicInfoComponent;